import { MovieStarIcon } from './MovieStarIcon';

/**
 * author: Colton Wiscombe
 * id 07D0534A-0D01-428A-8915-0C3930BE8C41
 * name movie-star
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-star.svg
 * tags
 * - Video / Movie 
 */
export const ClapperboardStarIcon = MovieStarIcon;
export default ClapperboardStarIcon